var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    itemsListPadding: spacing.small,
    itemPadding: spacing.xSmall,
    questionColor: colors.porcelain,
    dividerBorder: borders.widthMedium,
    dividerBorderColor: colors.licorice,
    questionBorder: borders.widthSmall,
    questionBorderColor: colors.tiara,
    responseBodyMarginRight: spacing.xxSmall,
    showComponentAnswerPadding: "".concat(spacing.xSmall, " ").concat(spacing.small),
    showComponentAnswerBorder: "".concat(colors.tiara, " 1px solid"),
    showComponentAnswerBorderRadius: spacing.xxSmall
  };
};
export default generateComponentTheme;